<script setup>
import {useBaseStore} from "~/stores/base";

const router = useRouter()
const route = useRoute()

/** emits **/
const emits = defineEmits(["close"])

/** props **/
const props = defineProps({
  title: String
})

/** data **/

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)

/** watch **/

/** methods **/

/** lifecycle **/

</script>

<template>
  <div class="module-header-mobile" v-if="isMobile">
    <div class="placeholder"/>
    {{ title }}
    <div class="close" @click="emits('close')">
      <img src="@/assets/img/icon-close-black.svg" alt="close">
    </div>
  </div>
  <div class="module-header-desktop" v-else>
    <div class="placeholder"/>
    {{ title }}
    <div class="close" @click="emits('close')">
      <img src="@/assets/img/icon-close-black.svg" alt="close">
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.module-header-mobile {
  padding: 16px;
  background-color: white;

  display: flex;
  justify-content: space-between;
  align-items: center;

  /* Eyebrow/medium */
  font-family: "TWK Lausanne";
  font-size: 14px;
  font-style: normal;
  font-weight: 650;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.056px;
  text-transform: uppercase;

  .placeholder {
    width: 40px;
    height: 40px;
  }

  .close {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.5px solid $color-BNTO-beige-dark;
    cursor: pointer;
  }
}

.module-header-desktop {
  padding: 16px;
  background-color: white;

  display: flex;
  justify-content: space-between;
  align-items: center;

  /* Eyebrow/medium */
  font-family: "TWK Lausanne";
  font-size: 14px;
  font-style: normal;
  font-weight: 650;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.056px;
  text-transform: uppercase;

  .placeholder {
    width: 40px;
    height: 40px;
  }

  .close {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.5px solid $color-BNTO-beige-dark;
    cursor: pointer;
  }
}
</style>
